<mat-spinner [diameter]="diameter"
             [strokeWidth]="strokeWidth"></mat-spinner>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/spinner/spinner.component.html